/**
 * Reducers for tethering (i.e. previewing questions from Question
 * Manager 2)
 */

import { Map, fromJS } from 'immutable';

import {
    SET_CHECKING_MODE,
    START_TETHERING,
    STOP_TETHERING,
    TETHER_QUESTION,
    TETHER_VIDEO,
} from './actions';

export const TETHERING_KEY = 'tethering';

export function tetheringReducer(state = Map(), action) {
    switch (action.type) {
        case START_TETHERING:
            return state.merge(
                fromJS({
                    isTethering: true,
                    sessionName: action.sessionName,
                }),
            );

        case STOP_TETHERING:
            // Stop tethering - reset all tethering state
            return Map({
                isTethering: false,
            });

        case TETHER_QUESTION:
            const question = fromJS(action.question);
            const questionState = {
                // Debug is used for the debug alert when user clicks on
                // question status bar
                debug: [
                    { title: 'SID', value: question.get('skillID') },
                    { title: 'QID', value: question.get('questionID') },
                ],
                // assetUrl: question.assetUrl,

                // Question data is stored so in tethering mode we can go back
                // to the question when the user answers it
                lastQuestion: question,
                video: null,

                previousTetherID: state.getIn(['lastQuestion', 'tetherID'], null),
            };
            return state.merge(fromJS(questionState));

        case TETHER_VIDEO:
            const video = action.video;
            const videoState = {
                video,
                // assetUrl: video.assetUrl,
                lastQuestion: null,
            };
            return state.merge(fromJS(videoState));

        case SET_CHECKING_MODE:
            return state.set('checking', action.checking);
    }

    return state;
}
